const RUNTIME_TYPES = {
    ALWAYS: 'ALWAYS',
    CUSTOM: 'CUSTOM',
};

export default RUNTIME_TYPES;
